de:
  SilverStripe\CMS\Controllers\CMSMain:
    NEWPAGE: '{pagetype} hinzufügen'
  NEWSENTRY:
    type_all: 'Alle'
    type_news: 'News'
    type_event: 'Veranstaltung'
    type_label: 'Typ'
    singular_name: 'Aktuelles-Eintrag'
    plural_name: 'Aktuelles-Einträge'
    read_more: 'Mehr anzeigen'
    read_less: 'Weniger anzeigen'
  BIRTHDAY:
    learn_more: 'Mehr erfahren'
    information: 'Informationen'
    group_size: 'Gruppengröße'
    costs: 'Kosten'
    duration: 'Dauer'
    hours: 'Stunden'
    additional_info: 'Weitere Informationen'
    age: 'Alter'
    years: 'Jahre'
    contact_title: 'Kontakt für mehr Informationen und Anmeldung'
    email: 'E-Mail'
    close: 'Schließen'
    Telefon: 'Telefon'
  VISITDETAILS:
    opening_hours: 'Öffnungszeiten'
    prices: 'Eintrittspreise'
  NAV:
    brand_aria: 'Startseite von Schloss Ahrensburg'
    brand_img_alt: 'Schloss Ahrensburg Logo'
    submenu_open: 'Untermenü öffnen'
    lang_change: 'Sprache ändern'
    lang_link: 'Sprache ändern zu'
    lang_menu: 'Sprachen'
  BREADCRUMB:
    nav_aria: 'Breadcrumb'
  BUTTON:
    link_aria: 'Link zu'
  FOOTER:
    instagram_alt: 'Logo von Instagram'
    facebook_alt: 'Logo von Facebook'
  NEWSLIST:
    pagination_nav: 'Seitennavigation'
    prev_page: 'Vorherige Seite'
    next_page: 'Nächste Seite'
